module.exports = __webpack_public_path__ + "static/cluttered-website-db5d5409a2e04843bc017f3f638b2f74.png";